module.exports = "/_next/static/images/up-monotone-70313c3d5f6b3927beeb40e438836f07.svg";